import { useState } from 'react';
import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as animationData from '../../../animations/recharge_card_lottie_animation/Cashback_animation.json';
import Recharge_card_lottie_animation from '../../../animations/recharge_card_lottie_animation/Recharge_card_lottie_animation';
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import Proceed_btn from '../../../common_components/common_btn/proceed_btn/Proceed_btn';
import Bill_payments from '../../../home/bill_payments/Bill_payments';
import Contribution from '../../../home/contribution/Contribution';
import Recharge_now from '../../../home/recharge_now/Recharge_now';
import "./Mobile_Recharge.css";

function Mobile_Recharge() {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };

    const services = [

        {
            id: 2,
            img: "/assets/images/home/bill_payments/satellite-dish.png",
            title: "DTH Recharge",
            baseLink: "/dth-recharge",
        },
        {
            id: 3,
            img: "/assets/images/home/bill_payments/light-bulb.png",
            title: "Electricity Bill",
            baseLink: "/electricity-recharge",
        },
        {
            id: 4,
            img: "/assets/images/home/bill_payments/gas-stove.png",
            title: "Gas Cylinder",
            baseLink: "/gas-recharge",
        },
        {
            id: 5,
            img: "/assets/images/home/bill_payments/buy-a-car.png",
            title: "FASTag Recharges",
            baseLink: "/fastag-recharge",
        },
    ];
    const navigate = useNavigate();

    const breadcrumbData = [
        { label: "Services", path: "/services" },
        { label: "Mobile Recharge" }
    ];

    const [rechargeType, setRechargeType] = useState("prepaid");

    const options = [
        { value: 'chocolate', label: 'Chocolate' },
        { value: 'strawberry', label: 'Strawberry' },
        { value: 'vanilla', label: 'Vanilla' }
    ]

    return (
        <>
            <Common_recharge_page_banner
                title="MOBILE RECHARGES"
                breadcrumbItems={breadcrumbData}
            />

            <section className="Mobile_Recharge">
                <div className="container">
                    <div className="Mobile_Recharge_container">
                        <div className="row">
                            <div className="col-md-7">
                                {/* Left Side - Form */}
                                <div className="recharge_form_section form_box_section">
                                    <div className="recharge_type_box">
                                        <div className="row align-items-center me-0 ms-0">
                                            <div className="col-xl-6">
                                                <h6>Select type of Recharge</h6>
                                            </div>
                                            <div className="col-xl-6">
                                                <div className="recharge_type_toggle">
                                                    <Form.Check
                                                        inline
                                                        label="Prepaid"
                                                        name="rechargeType"
                                                        type="radio"
                                                        id="prepaid"
                                                        checked={rechargeType === "prepaid"}
                                                        onChange={() => setRechargeType("prepaid")}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Postpaid"
                                                        name="rechargeType"
                                                        type="radio"
                                                        id="postpaid"
                                                        checked={rechargeType === "postpaid"}
                                                        onChange={() => setRechargeType("postpaid")}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Form className="recharge_form">
                                        <div className="form_row">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <Form.Group controlId="mobileNumber" className="form_field">
                                                        <Form.Label>Mobile Number</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter Mobile Number" />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-6">
                                                    <Form.Group controlId="operator" className="form_field">
                                                        <Form.Label>Operator</Form.Label>

                                                        <Select options={options} />

                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-6">
                                                    <Form.Group controlId="rechargeAmount" className="form_field">
                                                        <Form.Label>Recharge Amount</Form.Label>
                                                        <Form.Control type="text" placeholder="₹ Recharge Amount" />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-12">
                                                    <div className="btn_holder">
                                                        <Proceed_btn
                                                            btnText="Continue"
                                                            className="save_changes_btn"
                                                            onClick={() => navigate("/mobile-prepaid-recharge")}
                                                        />
                                                        <Proceed_btn btnText="View Plans" className={"cancle_btn"} onClick={() => navigate("/view-plans")} />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>
                            <div className="col-md-5">
                                {/* Right Side - Cashback Section */}
                                <div className="cashback_offer_section form_box_section">
                                    <div className="cashback_box">
                                        <div className='heading_holder'>
                                            <div className="cashback_heading">
                                                <h5>GET UP TO</h5>
                                                <h5>₹ 1000 CASHBACK</h5>
                                            </div>
                                            <span className="tnc_text">*T&C Apply</span>
                                        </div>
                                        <p>Complete three validity plan recharges to claim it!</p>
                                    </div>

                                    <div className="recharge_lottie_holder">
                                        <Recharge_card_lottie_animation defaultOptions={defaultOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            <Recharge_now/>
            <Bill_payments
                sectionTitle='EXPLORE OUR OTHER SERVICES'
                sectionSubtitle='From recharges to rewards, discover everything we offer in one place'
                services={services}
            />
            <Contribution />
        </>
    );
}

export default Mobile_Recharge;
